import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

import MemberEngagementView from '../../Model/Individual/StatisticsModel/MemberEngagementView';

import IntroMarkdown from './IntroMarkdown';

export default function EngagementChartRenderer(props) {
  const { data } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const {
    intro,
    allAgeGroups,
    engagementStates,
    engagementTotalCount,
    engagementMaxCount,
    engagementMaxKey,
    startDate,
    endDate,
  } = data;

  // 연령대 key → 다국어 라벨 매핑 //
  const keyToLabel = {
    under10: t('statistics.engagement.ageUnder10'),
    '10s': t('statistics.engagement.age10s'),
    '20s': t('statistics.engagement.age20s'),
    '30s': t('statistics.engagement.age30s'),
    '40s': t('statistics.engagement.age40s'),
    '50s': t('statistics.engagement.age50s'),
    '60s': t('statistics.engagement.age60s'),
    '70s': t('statistics.engagement.age70s'),
    '80s': t('statistics.engagement.age80s'),
    '90s': t('statistics.engagement.age90s'),
  };

  // 백엔드 집계 결과(key 기반) → 표시 뷰 규격(label 기반)으로 매핑 //
  const resolveLabel = (group) => ({ ...group, label: keyToLabel[group.key] || group.key });

  return (
    <TopLevelWrapper>
      <IntroMarkdown text={intro} color={theme.text} />
      <ContentWrapper $isDark={isDark}>
        <PeriodText fontFamily='NotoSansKR-Regular' fontSize={13} color={theme.subText}>
          {startDate + ' ~ ' + endDate}
        </PeriodText>
        <MemberEngagementView
          ageGroups={(allAgeGroups || []).map(resolveLabel)}
          engagementStates={(engagementStates || []).map(resolveLabel)}
          engagementTotalCount={engagementTotalCount}
          engagementMaxCount={engagementMaxCount}
          maxLabel={keyToLabel[engagementMaxKey] || engagementMaxKey} />
      </ContentWrapper>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 12px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: flex-start;

  padding: 20px 24px;

  width: calc(100% - 48px);

  gap: 10px;

  border-radius: 12px;
  background-color: ${props => props.theme.subBackground};
`;

const PeriodText = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 auto;
  cursor: default;
`;
